import React from "react";
import styles from "./LastSection.module.css";
import content from "../images/Contents.svg";
import profilePic from "../images/Avatar.svg";

const LastSection = () => {
  return (
    <section  className={`row  ${styles.testimonialSection}`}>
      <div className={`col-lg-5 ${styles.leftContent}`}>
        <div className={styles.stars}>★★★★★</div>
        <h2 className={styles.headerLast}>
          We’ve really speed up our workflow using Untitled <br/> and haven’t looked back.
        </h2>
        <div className={styles.customerInfo}>
          <img src={profilePic} alt="John Sparrow" className={styles.avatar} />
          <div>
            <p className={styles.name}>John Sparrow</p>
            <p className={styles.role}>Mortgage customers</p>
          </div>
        </div>
      </div>
      <div className={`col-lg-5 ${styles.rightContent}`}>
        <img src={content} alt="Testimonial Visualization" className={styles.image} />
      </div>
    </section>
  );
};

export default LastSection;
